"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0; // Copyright 2017-2020 @polkadot/x-textencoder authors & contributors
// SPDX-License-Identifier: Apache-2.0
// This is very limited, only handling Ascii values

var TextEncoder = /*#__PURE__*/function () {
  function TextEncoder() {
    _classCallCheck(this, TextEncoder);
  }

  _createClass(TextEncoder, [{
    key: "encode",
    value: function encode(value) {
      var u8a = new Uint8Array(value.length);

      for (var i = 0; i < value.length; i++) {
        u8a[i] = value.charCodeAt(i);
      }

      return u8a;
    }
  }]);

  return TextEncoder;
}();

exports.default = TextEncoder;